import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { WhatsAppFloat } from "./WhatsAppFloat";
import { MobileCtaBar } from "./MobileCtaBar";
import { FreeQuotePopup } from "./FreeQuotePopup";
import { captureAttribution } from "@/lib/attribution";

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => { captureAttribution(); }, []);
  const onDetail = /^\/packages\/.+/.test(pathname);
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      {!onDetail && <MobileCtaBar />}
      <FreeQuotePopup />
    </div>
  );
}
